// extracted by mini-css-extract-plugin
module.exports = {"ul":"List_ul__3iKys","ol":"List_ol__XEnRr","li":"List_li__eXXJH"};